The creation date & time that resulting webhook requests must precede.

This can be used to initiate the retrieval of paginated results.
Subsequent queries should use the opaque cursors returned from `WebhookRequestsConnection`.
